import Position from '@/views/position'
export default {
  path: 'position',
  name: 'user.attribute.position',
  component: Position
}



// WEBPACK FOOTER //
// ./src/router/positions/position.js